import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent } from '@ionic/react'
import { UseHeader, Icon, TipModal, MktConfirmModal } from '@cps'
import { modalLayer, useHistoryNew, toast } from '@utils'
import { memberMobx } from '@mobxStore'
import { FacebookProvider, LoginButton } from 'react-facebook'
import { GoogleLogin, GoogleLoginResponse } from 'react-google-login'
import i18n from 'i18next'
import './index.scss'

// interface
interface IProps extends IPage, RouteComponentProps {
}

const MyOthersBind: FC<IProps> = () => {
  const initData = [
    {
      title: i18n.t('mkt.common.facebook'),
      channel: 'facebook',
      isBind: false,
      bo: window.bo !== 'cn' ? window.bo : 'us'
    },
    {
      title: i18n.t('mkt.common.google'),
      channel: 'google',
      isBind: false,
      bo: window.bo !== 'cn' ? window.bo : 'us'
    },
    {
      title: i18n.t('common.CitconWechatWeb'),
      channel: 'wechat',
      isBind: false,
      bo: 'cn'
    },
    {
      title: i18n.t('common.CitconWechatMiniapp'),
      channel: 'wechatminiapp',
      isBind: false,
      bo: 'cn'
    },
    {
      title: i18n.t('common.CitconAlipayWeb'),
      channel: 'alipay',
      isBind: false,
      bo: 'cn'
    }
  ]
  const history = useHistoryNew()
  const { memberInfo } = memberMobx
  const { mobile, email } = memberInfo
  const [channelNum, setChannelNum] = useState<number>(0)
  const [isbind, setIsbind] = useState<boolean>(false)
  const [channelData, setChannelData] = useState<any>(initData)
  // Component Eveent
  const changeBind = (val: any) => {
    const unbind = !isbind && channelNum > 1 ? true : isbind
    const bindType = window.bo === 'cn' ? 'cn' : 'us'
    modalLayer(TipModal, {
      content: unbind ? i18n.t('mkt.unbind.comfirmTip') : i18n.t(`mkt.unbind.${bindType}Tip`),
      okText: unbind ? i18n.t('mkt.unbind.comfirmText', { name: val.title }) : i18n.t(`mkt.unbind.${bindType}Bind`)
    }, 'TipModal').then(() => {
      if (unbind) {
        confirmUnbind(val)
      } else {
        history.push('/iBind/all')
      }
    }, () => {})
  }
  const confirmUnbind = (info: any) => {
    modalLayer(MktConfirmModal, {
      cssClass: 'unbind-confirm-modal',
      content: i18n.t('mkt.unbind.unbindTip')
    }, 'MktConfirmModal').then(() => {
      memberMobx.unbindChannel({ memberChannelId: info.memberChannelId }).then(() => {
        toast({ message: i18n.t('mkt.unbind.unbindSuccess') })
        getBindList()
      })
    }, () => {})
  }
  const handleFbLogin = (response: IFacebookResponse) => {
    const obj = {
      channel: 'facebook',
      channelData: response.profile
    }
    memberMobx.bindChannel(obj).then((res: any) => {
      if (res.error) {
        toast({ message: i18n.t('mkt.unbind.bindFail') })
      } else if (res) {
        toast({ message: i18n.t('mkt.giftCard.bindSuccess') })
        getBindList()
      }
    })
  }
  const handleGgLogin = (response: GoogleLoginResponse) => {
    const obj = {
      channel: 'google',
      channelData: response.profileObj
    }
    memberMobx.bindChannel(obj).then((res: any) => {
      if (res.error) {
        toast({ message: i18n.t('mkt.unbind.bindFail') })
      } else if (res) {
        toast({ message: i18n.t('mkt.giftCard.bindSuccess') })
        getBindList()
      }
    })
  }
  const getBindList = () => {
    memberMobx.memberAllBind().then((res: any) => {
      setChannelNum(res.length)
      if (res.length > 0) {
        const newData = []
        initData.map((data: any) => {
          let hasBind = 0
          res.map((item: any) => {
            if (item.channel === data.channel) {
              item.isBind = true
              hasBind > 0 ? item.title = `${data.title}_${hasBind}` : ''
              newData.push({ ...data, ...item })
              hasBind = hasBind + 1
            }
          })
          if (hasBind === 0) newData.push(data)
        })
        setChannelData(newData)
      } else {
        setChannelData(initData)
      }
    })
  }
  const loginError = (error: any) => {
    console.error(error)
  }
  // Component Effect
  useEffect(() => {
    getBindList()
  }, [])
  useEffect(() => {
    if (window.bo === 'cn') {
      setIsbind(!!mobile)
    } else {
      if (mobile || email) {
        setIsbind(true)
      }
    }
  }, [mobile, email])
  return (
    <IonPage className='bind-page'>
      <UseHeader title={i18n.t('mkt.common.otherNum')} onBack={() => history.goBack()} />
      <IonContent className='page-content'>
        <div className='fix-block'></div>
        <div className='setting-list'>
          {
            channelData.map((item: any, index: number) => (
              <div key={index}>
                {
                  window.bo === item.bo &&
                    <div className='setting-item' onClick={() => { item.isBind ? changeBind(item) : '' }}>
                      <div className='name'>{item.title}</div>
                      <div className='link'>
                        <span className={item.isBind ? 'bind' : 'unbind'}>{item.isBind ? item.nickName : i18n.t('mkt.common.unBind')}</span>
                        {
                          (item.isBind || item.bo !== 'cn') && <Icon name='chevron-right' />
                        }
                      </div>
                      {
                        item.channel === 'google' && !item.isBind &&
                          <div className='type-item'>
                            <GoogleLogin
                              clientId='976087053892-fige93uf6uogiv6jcpu1sq7d4feqsjuo.apps.googleusercontent.com'
                              buttonText='Login'
                              onSuccess={handleGgLogin}
                              onFailure={loginError}
                              cookiePolicy='single_host_origin'
                            />
                          </div>
                      }
                      {
                        item.channel === 'facebook' && !item.isBind &&
                          <div className='type-item'>
                            <FacebookProvider appId={ENV.facebookAppId}>
                              <LoginButton
                                scope='email'
                                onCompleted={handleFbLogin}
                                onError={loginError}
                              >
                              </LoginButton>
                            </FacebookProvider>
                          </div>
                      }
                    </div>
                }
              </div>
            ))
          }
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(MyOthersBind)
